import React, { useEffect } from 'react'
import { useNavigate  } from "react-router-dom"
import './header.css'
import API_URL from '../common/Apiurl';

function Header(){
    const apiUrl = API_URL;
    const navigate  = useNavigate();
    useEffect(() => {
        if(!(localStorage.getItem('user-info'))){
            navigate('/')
        }
    },[navigate])
    async function handleLogout () {
        const result = await fetch(`${apiUrl}/adminlogout`,{
            method:'POST',
            headers:{
                "Authorization": 'Bearer ' + localStorage.getItem('user-token'),
                "Content-Type":"application/json",
                "Accept":"application/json",
            },
        });
        const data = await result.json();
        if((data.status === 200)){
            localStorage.removeItem("user-token");
            localStorage.removeItem("user-info");
            navigate('/')
        }
    }

    return (<>
            <div className="header">
                <div className="header-right">
                    {/* <a className="active" href="#home">Home</a>
                    <a href="#contact">Contact</a> */}
                    <button type="button" onClick={handleLogout} className='logoutBtn'>Logout</button>
                </div>
            </div>
        </>)
}

export default Header;